var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09424 6.01333C6.09424 4.85505 6.98849 3.91609 8.09161 3.91609C9.19473 3.91609 10.089 4.85505 10.089 6.01333C10.089 7.1716 9.19473 8.11056 8.09161 8.11056C6.98849 8.11056 6.09424 7.1716 6.09424 6.01333ZM7.39687 6.01333C7.39687 6.4162 7.70792 6.7428 8.09161 6.7428C8.4753 6.7428 8.78635 6.4162 8.78635 6.01333C8.78635 5.61045 8.4753 5.28385 8.09161 5.28385C7.70792 5.28385 7.39687 5.61045 7.39687 6.01333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1819 2.15623L15.8119 5.20179C16.0466 5.39906 16.1832 5.69764 16.1832 6.01333C16.1832 6.32901 16.0466 6.62759 15.8119 6.82487L12.1819 9.87042C9.78939 11.8756 6.39383 11.8756 4.00135 9.87042L0.371345 6.82487C0.136625 6.62759 0 6.32901 0 6.01333C0 5.69764 0.136625 5.39906 0.371345 5.20179L4.00135 2.15623C6.39383 0.151047 9.78939 0.151047 12.1819 2.15623ZM4.80897 8.84915C6.73027 10.4548 9.45294 10.4548 11.3742 8.84915L14.6916 6.01333L11.3742 3.22309C9.45294 1.61748 6.73027 1.61748 4.80897 3.22309L1.49161 6.01333L4.80897 8.84915Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.37366ec83f7288117b7759140a81bff7.svg";
export { ForwardRef as ReactComponent };